import React, { useEffect, useState } from "react";
import s from "./dump_styles/DumpFileList.module.css";

export default function DumpFileList() {
  const [files, setFiles] = useState([]);

  // const loadFiles = () => {
  //   fetch("/api/admin/dump/files")
  //     .then((res) => res.json())
  //     .then((data) => setFiles(data))
  //     .catch((err) => console.error("Ошибка загрузки дампов:", err));
  // };
  const loadFiles = () => {
  fetch("/api/admin/dump/files")
    .then((res) => {
      // Проверяем, что сервер ответил успехом (200 OK)
      if (!res.ok) {
        // Если пришло 403, 401 или 500, выбрасываем ошибку
        throw new Error(`Ошибка сервера: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      // Убеждаемся, что пришел именно массив
      if (Array.isArray(data)) {
        setFiles(data);
      } else {
        setFiles([]);
      }
    })
    .catch((err) => {
      console.error("Ошибка загрузки дампов:", err);
      // Если ошибка (включая 403), сбрасываем список в пустой массив, 
      // чтобы компонент не "ломался" при отрисовке
      setFiles([]);
    });
};

  useEffect(() => {
    loadFiles();
  }, []);

  const downloadFile = async (filename) => {
    try {
      const res = await fetch("/api/admin/dump/download", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ filename }),
      });
      if (!res.ok) throw new Error("Ошибка скачивания");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
    } catch (e) {
      alert("Ошибка при скачивании файла");
      console.error(e);
    }
  };

  const deleteFile = async (filename) => {
    if (!window.confirm(`Удалить дамп ${filename}?`)) return;

    try {
      const res = await fetch("/api/admin/dump/delete", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ filename }),
      });

      if (res.ok) {
        loadFiles();
      } else {
        alert("Ошибка удаления");
      }
    } catch (e) {
      alert("Ошибка при удалении файла");
      console.error(e);
    }
  };

  return (
    <div className={s.container}>
      <h3 className={s.heading}>Список дампов</h3>
      {files.length === 0 ? (
        <p className={s.empty}>Нет доступных дампов.</p>
      ) : (
        <table className={s.table}>
          <thead>
            <tr>
              <th>Файл</th>
              <th>Дата создания</th>
              <th>Размер (МБ)</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {files.map((file) => (
              <tr key={file.name}>
                <td>{file.name}</td>
                <td>{new Date(file.created_at).toLocaleString()}</td>
                <td>{file.size_mb}</td>
                <td>
                  <button className={s.button} onClick={() => downloadFile(file.name)}>📥</button>
                  {/* <button className={s.button} onClick={() => deleteFile(file.name)}>❌</button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
